<template>
    <v-app>
        <navigation-drawer />
        <v-main>
            <router-view />
        </v-main>
        <v-snackbar
            v-model="snackbar"
            top
            timeout="1500"
            :color="snackbarColor"
            text
        >
            {{ snackbarText }}
        </v-snackbar>
    </v-app>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import NavigationDrawer from './components/NavigationDrawer.vue';

export default {
    components: { NavigationDrawer },
    name: 'App',
    data: () => ({
        snackbar: false,
        snackbarText: '',
        snackbarColor: 'pink',
    }),
    computed: {
        ...mapGetters('auth', ['currentUser']),
    },
    methods: {
        ...mapActions('auth', ['updateToken']),
        initTheme() {
            this.$vuetify.theme.themes.light.primary = this.currentUser?.role !== 'manager' ? '#56A2E6' : '#4AB06F';
        },
    },
    mounted() {
        Vue.prototype.$showHint = (text) => {
            this.snackbar = true;
            this.snackbarText = text;
            this.snackbarColor = 'primary';
        };
        Vue.prototype.$showError = (text) => {
            this.snackbar = true;
            this.snackbarText = text;
            this.snackbarColor = 'error';
        };
        Vue.prototype.$showApiError = (e) => {
            const text = e.response?.data?.message || e.message;
            Vue.prototype.$showError(text);
        };
        this.$bus.$on('updateToken', this.updateToken);
        this.initTheme();
    },
    watch: {
        currentUser() {
            this.initTheme();
        },
    },
};
</script>
